import {Dispatch} from 'redux';
import {BEWpArticle} from '../../../API/types';
import {beWpArticleToTeaserArticle} from '../../../API/utils';
import {getTeaserWpArticles as APIgetTeaserArticles} from '../../../API/teaserWpArticles';
import {TeaserWpArticle} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';
import {
  TEASER_WP_ARTICLES_GET_INVALIDATE,
  TEASER_WP_ARTICLES_GET_REQUEST,
  TEASER_WP_ARTICLES_GET_RESPONSE,
} from '../../actionTypes';
import {
  TeaserWpArticlesGetInvalidateAction,
  TeaserWpArticlesGetRequestAction,
  TeaserWpArticlesGetResponseAction,
} from '../types';

/**
 * Action creator for the get request of the sport events by date
 */
const getTeaserArticlesGetRequest = (): TeaserWpArticlesGetRequestAction => ({
  type: TEASER_WP_ARTICLES_GET_REQUEST,
});

/**
 * Action creator for the request response of the sport events by date
 */
const getTeaserWpArticlesGetResponse = (data: TeaserWpArticle[]): TeaserWpArticlesGetResponseAction => ({
  type: TEASER_WP_ARTICLES_GET_RESPONSE,
  payload: {data},
});

/**
 * Action creator for the request invalidate of the sport events by date
 * @param error
 */
const getTeaserWpArticlesGetInvalidate = (error: Error): TeaserWpArticlesGetInvalidateAction => ({
  type: TEASER_WP_ARTICLES_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * // TODO: document
 */
const getTeaserArticles = () => (dispatch: Dispatch): Promise<any> => {
  dispatch(getTeaserArticlesGetRequest());

  return APIgetTeaserArticles()
    .then((data: BEWpArticle[]) => data.map(beWpArticleToTeaserArticle))
    .then((articles: TeaserWpArticle[]) => dispatch(getTeaserWpArticlesGetResponse(articles)))
    .catch((error: Error) => dispatch(getTeaserWpArticlesGetInvalidate(error)));
};

export default getTeaserArticles;
